var map = {
	"./all-page.svg": "Nz/5",
	"./arrows-maximize.svg": "ufRA",
	"./calendar-12.svg": "O8x6",
	"./calendar-alt-regular-515151.svg": "M/G1",
	"./calendar-alt-regular-999.svg": "Nxc3",
	"./calendar-disconnected-page.svg": "GDbh",
	"./circle-exclamation-alert.svg": "BrI7",
	"./clock-12.svg": "5UP8",
	"./code-pull-request-draft-solid-515151.svg": "HJFL",
	"./comment-alt-lines-regular.svg": "FETF",
	"./copy-duotone-dark.svg": "E3tj",
	"./copy-duotone.svg": "pjL2",
	"./draganddropfile.svg": "xXyZ",
	"./edit-user-blue.svg": "YEJT",
	"./ellipsis-v-regular.svg": "7alL",
	"./envelope-solid-515151.svg": "ACNf",
	"./face-smile-solid-dark.svg": "h6tz",
	"./face-smile-solid.svg": "wewC",
	"./floppy-disk-solid.svg": "LCSr",
	"./globe-asia-regular-515151.svg": "bUpE",
	"./house-solid-515151.svg": "d14+",
	"./line-brands-515151.svg": "XIjQ",
	"./logo.svg": "zxL1",
	"./mobile-alt-solid-515151.svg": "m3C2",
	"./no-msg.svg": "4hO1",
	"./payment/cod.svg": "yDoQ",
	"./pen-square-regular.svg": "6+9x",
	"./plus-circle-solid.svg": "TyAL",
	"./receipt-solid-515151.svg": "ABlT",
	"./reply-solid-dark.svg": "QhNL",
	"./reply-solid.svg": "SkAS",
	"./search-icon-bfbfbf.svg": "Vp/k",
	"./tag-solid-515151.svg": "Liak",
	"./tag-solid.svg": "moWp",
	"./times-light.svg": "ARxs",
	"./trash-alt-regular.svg": "MDJr",
	"./user-circle-solid-515151.svg": "8312",
	"./user-cog-solid-515151.svg": "ejRb",
	"./user-edit-regular-999.svg": "jJ3I",
	"./users-solid-515151.svg": "no/s",
	"./venus-mars-solid-515151.svg": "PtDy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KZtR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.svg$
// module id = KZtR
// module chunks = 31